import { useState, useEffect } from 'react';
import axios from 'axios';
import { deduplicateRequest } from '../../utils/requestDeduplication';

const API_URL = '/api';

export const useTotals = () => {
  const [totals, setTotals] = useState({
    services: 0,
    clients: 0,
    accounts: 0,
    movements: 0
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTotals = async () => {
    return deduplicateRequest('fetchTotals', async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/totals`);
        setTotals(response.data);
        setError(null);
      } catch (err) {
        console.error('Error:', err);
        setError('Error al cargar los totales. Por favor, intente de nuevo.');
      } finally {
        setLoading(false);
      }
    });
  };

  // Auto-fetch on mount
  useEffect(() => {
    fetchTotals();
  }, []);

  return {
    totals,
    loading,
    error,
    fetchTotals
  };
};